import React, { Component } from 'react';
import JobsTable from '../jobs/jobs-table.jsx';
import moment from 'moment';
export default class Driver extends Component {
  constructor(props) {
    super(props);
    let url = "/api/v1/portal/jobs/driver/" +
        props.data.driver.id +
        (props.viewAllJobs ? "/all-jobs" : "");

    this.state = {
      text: props.initialValue || 'placeholder',
      data: props.data || {
        driver: null
      },
      notes:props.data.driver.notes,
      isLoading: true,
      viewAllJobs: props.viewAllJobs || null,
      jobs: props.jobs || null,
      url: url || null,
      jobIds:[],
      driverDailyEarnings : props.driverDailyEarnings || '0.00',
      driverDailyEarningButtonColor : props.driverDailyEarningButtonColor,
      driverWeeklyEarnings : props.driverWeeklyEarnings || '0.00',
      driverWeeklyEarningButtonColor : props.driverWeeklyEarningButtonColor,
    };
    Echo.channel('driver-scheduled-list-update').listen('DriverScheduledListUpdate', (e) => {
      if(e.driverId){
        if(e.driverId == this.props.data.driver.id){
          this.getDriverJobs();
          $('#driver-table-list-'+e.driverId +' .late-driver-alert ').removeClass('late-driver-alert');
        }
      }else{
        if(this.state.jobs && this.state.jobs.length > 0){
          let Updateindex = this.state.jobs.findIndex(job => job.id == e.jobId);
          if(Updateindex != -1){
            this.state.jobs.splice(Updateindex, 1);
            this.setState({jobs:this.state.jobs});
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }
  getDriverJobs(){
    return fetch(
      this.state.url,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        }
      }
    ).then((responseText) => {
      let response = responseText.json();
      response.then((driverJson) => {
        this.setState({
          jobs: driverJson.data,
          driverDailyEarnings : driverJson.driverDailyEarnings,
          driverDailyEarningButtonColor : driverJson.driverDailyEarningButtonColor,
          driverWeeklyEarnings : driverJson.driverWeeklyEarnings,
          driverWeeklyEarningButtonColor : driverJson.driverWeeklyEarningButtonColor,
          isLoading: false
        });
        let jobIds = [];
          this.state.jobs.map((job)=>{
              jobIds.push(job.id);
              
          });
          this.setState({jobIds:jobIds});
          
      });
    });
  }
  componentDidMount() {
    if (this.state.isLoading) {
      this.getDriverJobs();
    }
  }
  componentDidUpdate() {
    let pickupTime = ['?','anytime','am','asap','pm'];
    let scheduledPickupTime = '';
    let scheduledPickupDate = '';
    let msg = null;
    if(this.state.jobs && this.state.jobs.length > 0){
      let tempJob = this.state.jobs[0];
      
      if(pickupTime.indexOf(tempJob.scheduled_pickup_time) != -1){
        //console.log('this.state.jobs',pickupTime.indexOf(tempJob.scheduled_pickup_time) + '= '+tempJob.scheduled_pickup_time + '= '+moment().format("HHmm a"));
        scheduledPickupTime = '0805';
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }else{
        //console.log('else',tempJob.scheduled_pickup_time);
        scheduledPickupTime = tempJob.scheduled_pickup_time;
        scheduledPickupDate = tempJob.scheduled_pickup_year+'-'+tempJob.scheduled_pickup_month+'-'+tempJob.scheduled_pickup_day;
      }
      /* check if appraisal is not set yet */
      if(tempJob.appraisal_id == null){
        let currentDate = moment().format('YYYY-MM-DD'); 
        if( (moment(currentDate).isSame(scheduledPickupDate)) && (moment().format("HHmm") > scheduledPickupTime)){
          msg = '<div><b>'+this.state.data.full_name+':</b> '+"<a target='_blank' href='/jobs/view/"+tempJob.id+"'> #"+tempJob.id+"</a> ("+this.state.data.driver.contact_number+')</div>';
          $('#jobs-table-row-'+tempJob.id).addClass('late-driver-alert');
          this.props.saveLateJobIdsOFDriver(tempJob.id);
        }
      }
    }
    this.props.handleLateDrivers(msg,this.state.data.id);
  }
  changeJobPrice(e) {
    let driverNotes = this.state.data.driver.notes;
    let holidayNotes = this.state.data.driver.holiday_notes;
    if (driverNotes === this.state.notes) {
      return null;
    }
    let changeJobPrice = confirm('change driver notes to:- '+ driverNotes + '?');
    if (changeJobPrice) {
      $.ajax({
        url: "/api/v1/portal/jobs/change-driver-notes/"+this.state.data.driver.id,
        data: {
          api_token: window.api_token,
          driver_notes: driverNotes,
          holiday_notes: holidayNotes
        },
        cache: false,
        method: 'post',
      })
      .done(function() {
        // 
      }).
      catch(function(e) {
        alert(e);
      });
    }
    else {
      $("input[name=job_price]").val(e.target.value);
    }
  }
  enterPressed(event) {
    let code = event.keyCode || event.which;
    if (code === 13) { // [ Enter ]
      $(event.target).trigger('blur');
    }
  }
  handleDriverNotesChange(event){
    
    this.state.data.driver.notes =  event.target.value
    this.setState({data: this.state.data});
    console.log(this.state.data.driver.notes);
  }
  handleDriverHolidayNotesChange(event) {
    this.state.data.driver.holiday_notes = event.target.value
    this.setState({ data: this.state.data });
  }
  render() {
    let schedulePanelColor = '';
    if(this.state.data.is_driver_one_job)
    {
      schedulePanelColor = 'schedule_panel_purple';
    }
    if(this.state.data.is_driver_new)
    {
      schedulePanelColor = 'schedule_panel_blue';
    }
    if(this.state.data.is_driver_sick)
    {
      schedulePanelColor = 'schedule_panel_green';
    }
    if(this.state.data.is_driver_do_not_pay)
    {
      schedulePanelColor = 'schedule_panel_red';
    }
    let did = "driver-table-list-"+this.state.data.driver.id;
    return(
    <div className="driver-table" id={did}>
      {
        this.state.isLoading ?
        <div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div> :

          ((  this.state.data &&
              this.state.data.driver &&
              this.state.data.driver.contact_number
            ) ?

              <div className="driver-container">
                <div className={"driver-main-info "+schedulePanelColor+""}>
                  <div className="row">
                    {/* <div className="col-md-1"> */}
                      {/* <img
                        src={"/user-images/" + this.state.data.id}
                        className="drivers-table-main-info-user-image"
                      /> */}
                    {/* </div> */}
                    <div className="col-md-4">
                      <img
                        src={"/user-images/" + this.state.data.id}
                        className="drivers-table-main-info-user-image"
                      />&nbsp;&nbsp;&nbsp;
                      {/* <strong>Driver Name:</strong>  */}
                      {
                      this.state.data.first_name} {
                      this.state.data.last_name}&nbsp;&nbsp;
                      <a
                        href={"/drivers/view/" + this.state.data.id +
                        "/all-jobs"}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="fa fa-car-side"></i> All Jobs
                      </a>
                      {/* Driver Daily Earning */}
                      <button type="button"
                        className={this.state.driverDailyEarningButtonColor}
                        data-toggle="tooltip" data-placement="right" data-original-title={this.state.driverDailyEarnings}
                      >
                        {this.state.driverDailyEarnings}
                      </button>
                      {/* Driver Weekly Earning */}
                      <button type="button"
                        className={this.state.driverWeeklyEarningButtonColor}
                        data-toggle="tooltip" data-placement="right" data-original-title={this.state.driverWeeklyEarnings}
                      >
                        {this.state.driverWeeklyEarnings}
                      </button>
                      <input type="text" className="float-right"
                        value={this.state.data.driver.holiday_notes}
                        placeholder="- Add Holiday Notes -"
                        onChange={(e) => this.handleDriverHolidayNotesChange(e)}
                        name="holiday_notes" />
                    </div>
                    <div className="col-md-2 filter-date-section" style={{display: "inherit"}}>
                        {/* <textarea className="form-control form-control-lg"
                          name="driver_notes"
                          id="driver_notes"
                          placeholder="Add Notes"
                          defaultValue={this.state.data.driver.notes}
                          onChange={(e)=>this.handleDriverNotesChange(e)}>
                        </textarea> */}
                        <input type="text" className="jobs-table-editable form-control form-control-lg driver-notes-textbox"
                          value={this.state.data.driver.notes}
                          placeholder="- Add Notes - "
                          onChange={(e)=>this.handleDriverNotesChange(e)}
                          name="notes" />&nbsp;&nbsp;
                          <a title="update driver notes & holiday notes" 
                             onClick={this.changeJobPrice.bind(this)}>
                               <i className="fa fa-lg fa-sync"></i>
                          </a>
                    </div>
                    <div className="col-md-3">
                      <i className="fa fa-phone"></i> {
                      this.state.data.driver.contact_number}
                      <i className="fa fa-envelope ml-3"></i>&nbsp; {
                        this.state.data.email}
                    </div>
                    {/* <div className="col-md-2">
                      <strong>Trade Plate:</strong>&nbsp;
                      <i className="fa fa-phone"></i> {
                      this.state.data.driver.contact_number}
                    </div>
                    <div className="col-md-2">
                        <i className="fa fa-envelope"></i>&nbsp; {
                        this.state.data.email}
                      </div> */}
                      { (this.state.data.driver.home_address) ? 
                      <div className="col-md-3">
                        <i className="fa fa-home"></i> {
                        this.state.data.driver.home_address.town_city} {
                        this.state.data.driver.home_address.county_area}&nbsp;&nbsp; | &nbsp;&nbsp;
                        <strong className="pFixed">Active/Working:&nbsp;&nbsp;
                          <button className="btn btn-primary buttonActiveWorking">
                            <b>{(this.state.data.driver.active_status) ? 'YES' : 'NO'}</b>
                          </button>
                        </strong>
                      </div>
                      : ''
                      }
                  </div>
                </div>
                <JobsTable
                  url={this.state.url}
                  jobs={this.state.jobs}
                  noCategoryLabels={true}
                  message_if_none='No Jobs found. Add one to see it here.'
                  driverScreen={(this.state.url.search('all-jobs') > -1) ? false : true}
                  jobIds={this.state.jobIds}
                />
              </div>
              : ''
          )
        }
      </div>
    );
  }
}
